<template>
  <div class="common-page staff-management">
    <div class="search-form-box">
      <el-row :gutter="30">
        <el-form inline>
          <el-col :span="5">
            <el-form-item label="关联代理商">
              <el-select placeholder="请选择" v-model="searchForm.agentCompanyId">
                <el-option
                  v-for="item in agentData"
                  :key="item.companyId"
                  :label="item.companyName"
                  :value="item.companyId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="搜索">
              <el-input
                style="width: 100%"
                clearable
                v-model="searchForm.keyword"
                autocomplete="off"
                placeholder="应用名/appKey"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5" v-if="companyType === '1'">
            <el-form-item label="分公司:">
              <el-select style="width: 100%" v-model="searchForm.belongCompanyId" placeholder="请选择">
                <el-option
                  v-for="item in belongCompanyData"
                  :key="item.companyId"
                  :label="item.companyName"
                  :value="item.companyId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item label="">
              <el-button type="primary" @click="handleCheck()">查询</el-button>
              <el-button type="default" @click="handleReset(['belongCompanyId'])">重置</el-button>
              <el-button type="success" @click="handleAdd()">新增应用</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange"
      >
        <template v-slot:appSecret="{ row }">
          <el-button  @click="handleCopy($event, row.appSecret)">复制</el-button>
        </template>
        <template v-slot:appStatus="{ row }">
          <span @click="handleStatus(row)">
            <el-switch :value="row.appStatus"
                       :inactive-value="2"
                       :active-value="1"
                       size="medium"
                       active-color="#526BEC" >
            </el-switch>
          </span>
        </template>
        <template v-slot:operation="{ row }">
          <div>
            <span class="operate-btn" @click.stop="handleEdit(row)">编辑</span>
            <span class="operate-btn" @click.stop="handleResetSecret(row)"
              >重置秘钥</span
            >
            <span
              class="operate-btn delete-btn"
              @click="handleDelete(row.appId, '确定要删除此应用吗？')"
              >删除</span
            >
          </div>
        </template>
      </custom-table>
    </div>

    <!--    添加或编辑-->
    <addOrEdit ref="addOrEdit"></addOrEdit>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import addOrEdit from "./addOrEdit.vue";
import { deleteInfo, externalAppStatus, getPage, resetSecret } from "./api";
import tableMixin from "@/mixin/tableMixin";
import { getSelectAgent } from "@/views/SystemManagement/AgentManagement/api";
import handleClipboard from "@/utils/copy";
export default {
  name: "ExternalAppManagement",
  mixins: [tableMixin],
  components: {
    OperateBox,
    CustomTable,
    addOrEdit,
  },
  data() {
    return {
      getTableMethod: getPage,
      deleteMethod: deleteInfo,
      downloadLoading: false,
      searchForm: {
        belongCompanyId: "",
        agentCompanyId: "",
        keyword: "",
      },
      isImmediatelyGetData: true,
      haveBelongCompany: true,
      tableColumn: [
        {
          label: "代理商名称",
          prop: "agentCompanyName",
          align: "left",
          show: true,
        },
        {
          label: "应用名",
          prop: "appName",
          show: true,
        },
        {
          label: "APP_KEY",
          prop: "appKey",
          show: true,
        },
        {
          label: "秘钥",
          prop: "appSecret",
          scopeStatus: true,
          show: true,
        },
        {
          label: "状态",
          prop: "appStatus",
          scopeStatus: true,
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          width: "200px",
          scopeStatus: true,
          fixed: "right",
          show: true,
        },
      ],
      agentData: []
    };
  },
  created() {
    this.getAgentData()
  },
  mounted() {},
  methods: {
    handleCopy($event, txt) {
      handleClipboard($event, txt);
    },
    getAgentData() {
      getSelectAgent({
        keyword: '',
        belongCompanyId: ''
      }).then(response => {
        if (response.code === 200) {
          this.agentData = response.data
        }
      })
    },
    handleResetSecret(row) {
      this.$confirm(`确定重置此应用秘钥？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        resetSecret({ appId: row.appId }).then((res) => {
          if (res.code === 200) {
            this.$message.success("秘钥重置成功");
            this.getTableData();
          }
        });
      });
    },
    handleStatus(row) {
      this.$confirm(`确定${!row.status ? "启用" : "禁用"}此应用？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        externalAppStatus({ appId: row.appId, appStatus: row.appStatus === 1 ? 2 : 1 }).then(
          (res) => {
            if (res.code === 200) {
              this.getTableData();
            }
          }
        );
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.custom-table-box{
  padding-top: 0;
}
.business-management {
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }
  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }
}
</style>
